/** Zuletzt erzeugte Datei: bleibt als Link stehen, falls der automatische Download nicht startet. */
export interface ReadyFile {
  url: string;
  filename: string;
}

let ready: ReadyFile | null = null;
const listeners = new Set<() => void>();

function publish(next: ReadyFile | null): void {
  if (ready !== null && ready.url !== next?.url) URL.revokeObjectURL(ready.url);
  ready = next;
  for (const listener of listeners) listener();
}

/** Für `useSyncExternalStore`: die Leiste „Datei bereit“ im Seitenrahmen. */
export const readyFileStore = {
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  get: (): ReadyFile | null => ready,
  dismiss: (): void => {
    publish(null);
  },
};

/**
 * Startet den Download einer Datei im Browser (der Blob liegt nur im Speicher, nichts wird zwischengespeichert).
 * Auf dem Handy startet ein Download nach einer Wartezeit oft nicht mehr (die Geste „Antippen“ ist abgelaufen);
 * deshalb bleibt die Datei zusätzlich als Link „Öffnen“ stehen, den man selbst antippt.
 */
export function saveFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  publish({ url, filename });
}
